// extracted by mini-css-extract-plugin
export default {"rtm_header":"RTM_rtm_header__x07mi","enabled_wrapper":"RTM_enabled_wrapper__+ATUQ","indicator":"RTM_indicator__voq3d","start_note":"RTM_start_note__xg9W5"};